import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledLink = styled.span`
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: underline;
  cursor: pointer;
`;

// Router-aware variant for in-app navigation (wraps react-router's Link).
export const StyledRouterLink = styled(Link)`
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: underline;
  cursor: pointer;
`;
